import React from "react"

import NavLink from '../../components/Routes/NavLink'
import moment from 'moment'

import { leads } from '../../core/controllers/Leads';
import { tenants } from '../../core/controllers/tenants'
import { workOrders } from '../../core/controllers/WorkOrders';
import { properties } from '../../core/controllers/Properties';
import { leases } from '../../core/controllers/Leases';
import { payables } from '../../core/controllers/Payables';
import { owner } from '../../core/controllers/Owner';

import { financial } from '../../core/controllers/Financial';

export class Card extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: <img style={{display: "inline", maxHeight: "53px", maxWidth: "53px"}} src="/assets/img/request_loader.gif"/>,
        }
        this._mounting = true;
    }

    componentWillUnmount() {
        this._mounting = false;
    }

    componentDidMount() {
        this._mounting && this.props.query(data => {
            this._mounting && this.setState({
                data: data
            })
        })
    }

    componentDidUpdate(prevProps) {
        prevProps != this.props && (
            this.props.query(data => {
                this.setState({
                    data: data
                })
            })
        )
    }

    render(){
        const iconClass = this.props.iconClass
        const color = this.props.color
        const clickable = this.props.clickable
        const url = clickable ? (this.props.url) : ("Error: no url")
        const title = this.props.title
        const description = this.props.description
        const siblingCount = this.context.numberOfSiblings || 0

        return (
            <NavLink to={this.props.clickable ? url : null}>
                <div class="ps-info-box" style={{
                        fontSize: `clamp(0.8rem, 2vw / ${siblingCount + 1}, 1.15rem) `,
                        maxWidth: "100%"
                    }}
                >
                    <span class={`ps-info-box-icon ${color}-icon-circle`} style={{
                            height: `clamp(35px, 10vw / ${siblingCount + 1}, 50px)`,
                            width: `clamp(35px, 10vw / ${siblingCount + 1}, 50px)`
                        }}
                    >
                        <i class={`ps-info-box-icon-icon ${iconClass}`} />
                    </span>
                    <div class="ps-info-box-content">
                        <span class="ps-info-box-text">
                            {title}
                        </span>
                        <br />
                        <span class="ps-info-box-subtext">
                            {description}
                        </span>
                        <span class={`${color}-info-number ps-info-box-number`}>
                            {this.state.data}
                        </span>
                    </div>
                </div>
            </NavLink>
        )
    }
};

// ./../../components/Tenants/NewTenantsCard.jsx
export const NewTenants = props => <Card
        query = { callback => {
            tenants.getTenants(null, function(response) {
                let totalNewTenants = 0
                response.data.map(function(tenant) {
                    let timeSinceSigned = moment() - moment(tenant.data.created_date)
                    if (( timeSinceSigned * 0.001 / 86400) <= 7) {
                        totalNewTenants += 1
                    }
                })
                callback(totalNewTenants);
            });
        }}
        iconClass   = "icon-new"
        color       = "green"
        url         = "/tenants?filter=recent_added"
        clickable   = {props.clickable}
        title       = "New Tenants"
        description = "Over the last 7 days"
    />

// ./../../components/Tenants/TotalTenantsCard.jsx
export const TotalTenants = props => <Card
        query = { callback => {
            tenants.getTenants(null, function (response) {
                if (response.data != null) {
                    callback(response.data.length)
                }
            });
        }}
        iconClass   = "icon-person-group"
        color       = "green"
        clickable   = {false}
        title       = "Total"
        description = "Total Tenants"
    />

// ./../../components/Leads/FollowUpLeadsCard.jsx
export const FollowUpLeads = props => <Card
        query = { callback => {
            leads.getLeadsAsync(props.followUp, function (response) {
                if (response.data != null) {
                    callback(response.data.length);
                }
            });
        }}
        iconClass   = "icon-person-star"
        color       = "green"
        url         = "/leads?filter=follow_up"
        clickable   = {props.clickable}
        title       = "New Leads"
        description = "Over the last 7 days"
    />

// ./../../components/Financial/LateRent.jsx
export const LateRent = props => <Card
        query = { callback => {
            financial.getLateRent(props.startDate, props.endDate, function (response) {
                callback(
                    (response.data.laterent).toLocaleString('en-US', {
                        currency: 'USD',
                    })
                );
            })
        }}
        iconClass   = "icon-timer"
        clickable   = {false}
        color       = "orange"
        title       = "Late Rent"
        description = "Renthat is overdue days"
        startDate   = {props.startDate}
        endDate   = {props.endDate}
    />

// ./../../components/Leases/ExpiringLeasesCard.jsx
export const ExpiringLeases = props => <Card
    query = { callback => {
        leases.getLeases(0, 'expiring', function(response) {
            if (response.data != null) {
                callback(response.data.length);
            } else {
                callback(0);
            }
        });
    }}
    iconClass   = "icon-document-timer"
    clickable   = {props.clickable}
    url         = "/leases?filter=expiring"
    color       = "orange"
    title       = "Expiring Leases"
    description = "Over the next 30 days"
/>

// ../../components/financial/PendingRent.jsx
export const PendingRent = props => <Card
        query = { callback => {
            financial.getPendingRent(function () {
                financial.getIncome(props.startDate, props.endDate, function (response) {
                    callback(
                        (response.data.income).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        })
                    );
                });
            });
        }}
        iconClass   = "pe-7s-cash"
        clickable   = {false}
        color       = "yellow"
        title       = "Pending Rent"
        description = ""
    />

// ./../../components/WorkOrders/WorkOrdersPriorityRequestCard.jsx
export const WorkOrdersPriorityRequest = props => <Card
        query = { callback => {
            workOrders.getWorkOrderCount("High,Emergency", function(response){
                callback(response.data);
            });
        }}
        iconClass   = "icon-alert"
        clickable   = {props.clickable}
        url         = "/maintenance?filter=priority"
        color       = "red"
        title       = "Priority Requests"
        description = "Currently active"
    />

// ./../../components/WorkOrders/WorkOrdersActiveRequestCard.jsx
export const WorkOrdersActiveRequest = props => <Card
        query = { callback => {
            workOrders.getWorkOrders("Pending,In Progress", null, function(response){
                if (response.data != null) {
                    callback(response.data.length);
                }
            });
        }}
        iconClass   = "icon-wrench"
        clickable   = {false}
        color       = "green"
        title       = "Active Requests"
        description = "Currently submitted"
    />

// ./../../components/WorkOrders/WorkOrdersNewRequestCard.jsx
export const WorkOrderNewRequests = props => <Card
        query = { callback => {
            workOrders.getWorkOrders("LastSevenDays", null, function (response) {
                if (response.data != null) {
                    callback(response.data.length);
                }
            });
        }}
        iconClass       = "icon-browser-wrench"
        clickable       = {props.clickable}
        url             = "/maintenance?filter=LastSevenDays"
        color           = "blue"
        title           = "New Requests"
        description     = "Over the last 7 days"
    />

// ./../../components/WorkOrders/WorkOrdersCompletedCard.jsx
export const WorkOrdersCompleted = props => <Card
        query = { callback => {
            workOrders.getWorkOrders("Completed", null, function (response) {
                if (response.data != null) {
                    callback(response.data.length);
                }
            });
        }}
        iconClass   = "icon-checklist"
        clickable   = {false}
        color       = "gray"
        title       = "Compeleted"
        description = "Total requests"
    />

// app/components/Financial/Income.jsx
export const Income = props => <Card
        query = { callback => {
            financial.getIncome(props.startDate, props.endDate, function (response) {
                callback(
                    (response.data.income).toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    })
                );
            });
        }}
        iconClass   = "icon-piggy-bank"
        clickable   = {false}
        color       = "blue"
        title       = "Income"
        description = "Total income received"
        startDate   = {props.startDate}
        endDate   = {props.endDate}
    />

// app/components/Financial/Expense.jsx
export const Expense = props => <Card
        query = { callback => {
            financial.getExpense(props.startDate, props.endDate, function (response) {
                var expense = (response.data.expense).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });
                callback(expense);
            });
        }}
    iconClass= "icon-money-arrow"
        clickable   = {false}
        color       = "red"
        title       = "Expenses"
        description = "Total expenses incurred"
        startDate   = {props.startDate}
        endDate   = {props.endDate}
    />

// ./../../components/Payables/Vendors/VendorTotalBillsDeclinedCard.jsx
export const VendorTotalBillsDeclined = props => <Card
        query = { callback => {
            payables.getVendorBillsDeclined(function(response) {
                callback(response.data);
            })
        }}
        iconClass   = "icon-house-with-level"
        clickable   = {false}
        color       = "red"
        title       = "Total Bills Declined"
        description = "For this vendor"
    />

// ./../../components/Payables/Vendors/VendorTotalBillsPendingCard.jsx
export const VendorTotalBillsPending = props => <Card
        query = { callback => {
            payables.getVendorBillsPending(function(response) {
                callback(response.data);
            })
        }}
        iconClass   = "icon-house-with-level"
        clickable   = {false}
        color       = "orange"
        title       = "Total Bills Declined"
        description = "For this vendor"
    />

// ./../../components/Payables/Vendors/VendorTotalBillsApprovedCard.jsx
export const VendorTotalBillsApproved = props => <Card
        query = { callback => {
            payables.getVendorBillsApproved(function(response) {
                callback(response.data);
            })
        }}
        iconClass   = "icon-house-with-level"
        clickable   = {false}
        color       = "green"
        title       = "Total Bills Pending"
        description = "For this vendor"
    />

// ./../../components/Owners/OwnerExpectedIncomeCard.jsx
export const OwnerExpectedIncome = props => <Card
        query = { callback => {
            owner.getOwnerExpectedIncome(function (response) {
                if (response.data != null) {
                    callback("$" + `${response.data}`);
                }
            });
        }}
        iconClass   = "icon-piggy-bank"
        clickable   = {false}
        color       = "orange"
        title       = "Income"
        description = "Payouts received this month"
    />

export const OwnerTotalProperties = props => <Card
        query = { callback => {
            properties.getProperties(0, function (response) {
                if (response.data != null) {
                    callback(response.data.length);
                }
            });
        }}
        iconClass   = "icon-house-with-level"
        clickable   = {false}
        color       = "green"
        title       = "Total"
        description = "Total Properties"
    />

// ./../../components/Leases/TotalLeaseCard.jsx
export const TotalLeases = props => <Card
        query = { callback => {
            leases.getLeases("0", null, function(response) {
                if (response.data != null) {
                    callback(response.data.length);
                }
            });
        }}
        iconClass   = "icon-documents-stack"
        clickable   = {false}
        color       = "blue"
        title       = "Total"
        description = "Total Leases"
    />

// ./../../components/Leases/VacantLeasesCard.jsx
export const VacantLeases = props => <Card
        query = { callback => {
            leases.getAllEmptyLeases(function(response) {
                callback(response.data);
            });
        }}
        iconClass   = "icon-house-alert"
        clickable   = {props.clickable}
        url         = "/leases?filter=vacancies"
        color       = "red"
        title       = "Vacant Leases"
        description = "Currently not active"
    />

// ./../../components/Leases/AwaitingESigCard.jsx
export const AwaitingESig = props => <Card
        query = { callback => {
            leases.getLeases("0", null, function(response) {
                var count = 0;
                response.data.map(function(lease) {
                    if (lease.agreement != null) {
                        if (lease.agreement.pending != null && lease.agreement.pending == 1) {
                            count += 1
                        }
                    }
                })
                callback(count);
            });
        }}
        iconClass   = "icon-pen"
        clickable   = {false}
        color       = "green"
        title       = "Awaiting E-Sig"
        description = "Waiting on tenant to sign"
    />

// ./../../components/Tenants/TenantsLateOnRentTallyCard.jsx
export const TenantsLateOnRentTally = props => <Card
        query = { callback => {
            tenants.tenantsLateOnRentTally(function(response) {
                callback(response.tally);
            });
        }}
        iconClass   =   "icon-credit-card-slot"
        clickable   =   {props.clickable}
        url         =   "/tenants?filter=late"
        color       =   "red"
        title       =   "Late On Rent"
        description =   "Tenants behind on rent"
    />

Card.contextTypes = {
    numberOfSiblings: React.PropTypes.number
}



// WEBPACK FOOTER //
// app/helpers/Cards/Cards.jsx